import {
  type AxiosRequestConfig,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';

/**
 * CampaignBanner — hệ banner mới (AF-062), gộp Strapi hero + /tag super-deal
 * vào một API public v4. Webstore: FEATURED_BANNER → hero, SUPER_DEAL → dải deal.
 */
export type BannerScreen =
  | 'home'
  | 'city_landing'
  | 'store_listing'
  | 'store_detail';

export type BannerType =
  | 'FEATURED_BANNER'
  | 'HOT_DEAL'
  | 'SUPER_DEAL'
  | 'ADS'
  | 'STORE_COLLECTION';

export type ServiceType = 'AIFOOD' | 'RIDE' | 'EXPRESS';

export interface CampaignBanner {
  _id: number;
  type: BannerType;
  /** Ảnh chính — hiển thị mọi breakpoint (FE crop/focal-point cho mobile). */
  image_url: string;
  title_vi_vn: string;
  title_en_us?: string;
  description_vi_vn?: string;
  description_en_us?: string;
  background_image_url?: string;
  /** Link mở web — CTA khi bấm banner. */
  link?: string;
  deep_link?: string;
  screen?: BannerScreen[];
  service_types?: ServiceType[];
  city_ids?: string[];
  store_ids?: number[];
  order?: number;
  color?: string;
  start_time?: number;
  end_time?: number;
}

export interface GetCampaignBannersParams {
  city_id: string;
  // BE hỗ trợ array (lặp key: type=A&type=B) → 1 call lấy nhiều type/screen.
  service_type?: ServiceType | ServiceType[];
  screen?: BannerScreen | BannerScreen[];
  type?: BannerType | BannerType[];
}

/**
 * Public — webstore đọc banner (lọc + sort do BE). Response có thể là mảng trần
 * hoặc `{ banners: [...] }` → chuẩn hoá về mảng.
 */
export const getCampaignBannersFn = async (
  params: GetCampaignBannersParams,
  config: AxiosRequestConfig = {}
): Promise<CampaignBanner[]> => {
  const res = await publicHttpClient.get<
    CampaignBanner[] | { banners: CampaignBanner[] }
  >(apiRoutes.ahafood.store.get_campaign_banners, {
    params: { service_type: 'AIFOOD', ...params },
    // array → lặp key không index (type=A&type=B) đúng format BE mong đợi
    paramsSerializer: { indexes: null },
    ...config,
  });
  const data = res?.data;
  return Array.isArray(data) ? data : (data?.banners ?? []);
};
